import { MockSearchCustomerApiResponse, MockSearchCustomerSearchParams } from './formModel';
import { mockCustomerData } from './resultsMock';

export const mockSearchCustomerAPI = async (
  searchValues: MockSearchCustomerSearchParams
): Promise<MockSearchCustomerApiResponse> => {
  const mockData = await new Promise<typeof mockCustomerData>((resolve) => {
    setTimeout(() => resolve(mockCustomerData), 300);
  });
  const allItems = mockData.pages.flat();
  const { pageSize } = mockData;

  const normalize = (value?: string) => (value ?? '').trim().toLowerCase();
  const digitsOnly = (value?: string) => (value ?? '').replace(/\D/g, '');
  const page = searchValues.page ?? 1;

  const search = {
    firstName: normalize(searchValues.firstName),
    lastName: normalize(searchValues.lastName),
    dateOfBirth: normalize(searchValues.dateOfBirth),
    address: normalize(searchValues.address),
    mobileNumber: digitsOnly(searchValues.mobileNumber),
    email: normalize(searchValues.email),
  };

  const hasAtLeastOneFilter = Object.values(search).some((value) => value.length > 0);

  if (!hasAtLeastOneFilter) {
    return {
      items: [],
      pagination: {
        currentPage: 1,
        totalPages: 1,
        pageSize,
        totalItems: 0,
      },
    };
  }

  const filteredItems = allItems.filter((item) => {
    const itemValue = {
      firstName: normalize(item.firstName),
      lastName: normalize(item.lastName),
      dateOfBirth: normalize(item.dateOfBirth),
      address: normalize(item.address),
      countryCode: digitsOnly(item.countryCode),
      mobileNumber: digitsOnly(item.mobileNumber),
      email: normalize(item.email),
    };

    const firstNameMatches = search.firstName && itemValue.firstName.includes(search.firstName);
    const lastNameMatches = search.lastName && itemValue.lastName.includes(search.lastName);
    const dateOfBirthMatches = search.dateOfBirth && itemValue.dateOfBirth === search.dateOfBirth;
    const addressMatches = search.address && itemValue.address.includes(search.address);
    const phoneMatches = search.mobileNumber && itemValue.mobileNumber.includes(search.mobileNumber);
    const emailMatches = search.email && itemValue.email.includes(search.email);

    return firstNameMatches || lastNameMatches || dateOfBirthMatches || addressMatches || phoneMatches || emailMatches;
  });

  const totalItems = filteredItems.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  const currentPage = Math.min(Math.max(page, 1), totalPages);
  const startIndex = (currentPage - 1) * pageSize;
  const items = filteredItems.slice(startIndex, startIndex + pageSize);

  return {
    items,
    pagination: {
      currentPage,
      totalPages,
      pageSize,
      totalItems,
    },
  };
};
